<template>
  <div>
    <b-modal id="delete_modal" title="Invite users" class="theme-modal" hide-footer
             no-close-on-backdrop>
      <div>
        <h4 class="modal-title w-100 text-center">Are you sure?</h4>
        <p class="mt-2 text-center">Do you really want to delete these records? This process cannot be undone.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'DeleteModal',
  methods: {
    openModal() {
      this.$bvModal.show('delete_modal')
    },
    action() {
    }
  }
}
</script>